"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../theme");
exports.default = styled_1.default.div `
.stat-tile {
	display: inline-block;
	padding: ${theme_1.default.spacing.large};
	min-width: 200px;
	border: 1px solid ${theme_1.default.colours.delimiter.default};
	border-radius: ${theme_1.default.layout.radius.default};
	background: linear-gradient(-45deg, #0D8667 0%, #1CA784 100%);
	background-color: ${theme_1.default.colours.success.light};
    box-shadow: 0px 2px 4px 0px var(--colour-shadow);
	-webkit-font-smoothing: antialiased;
}

.stat-tile__red {
	background: linear-gradient(135deg, #EB6B8B 0%, #C9365B 100%);
	background-color:  ${theme_1.default.colours.error.light};
}

.stat-tile__green {
	background: linear-gradient(-45deg, #0D8667 0%, #1CA784 100%);
	background-color: ${theme_1.default.colours.success.light};
}

.stat-tile__blue {
	background: linear-gradient(135deg, #0A67E5 0%, #0D55B6 100%);
}

.stat-tile__row {
	color: white;
	font-size: var(--font-size-t2);
}

.stat-tile__link {
	text-decoration: none;
}

.stat-tile__symbol, .stat-tile__link__symbol {
	color: white;
	font-size: 80px;
	font-family: var(--font-medium);
	text-shadow: 1px 5px 3px #00000010;
}

.stat-tile__link__arrow {
	transform: rotate(270deg);
	display: block;
	position: absolute;
	right: 560px;
	top: 413px;
	font-size: 75px;
}

.stat-tile__link__arrow span {
	color: white;
}

.stat-tile__link__first-label, .stat-tile__first-label {
	font-weight: bold;
}

.stat-tile__link__second-label, .stat-tile__second-label {
	margin-top: 2px;
}
`;
//# sourceMappingURL=stats-tile.styled.js.map